<template>
  <app-fade-transition>
    <app-panel v-show="teachers.length > 0" :title="title">
      <ul class="grid gap-3">
        <li v-for="teacher in teachers" :key="teacher.id">
          <app-card-link-background :to="teacher._links.teacherPage">
            <figure class="flex items-center gap-3">
              <app-user-avatar
                :avatar-url="teacher.avatar_url"
                :name="teacher.full_name"
                :size="54"
                tile
              />

              <figcaption>
                <p class="font-semibold">
                  {{ teacher.full_name }}
                </p>
                <p class="text-subtle text-sm">
                  {{ teacher.job }}
                </p>

                <p>
                  <teacher-companies-logos
                    :companies="teacher.companies"
                    :height="16"
                    variant="flat"
                  />
                </p>
              </figcaption>
            </figure>
          </app-card-link-background>
        </li>
      </ul>
    </app-panel>
  </app-fade-transition>
</template>

<script lang="ts" setup>
const properties = defineProps<{
  tag: DatabaseTable<"tags">;
}>();

const { data: teachers } = useTeacherList(
  `course_related_teachers_${properties.tag.slug}`,
  {
    tags: [properties.tag.slug],
    limit: 5,
  },
  { server: false },
);

const title = computed(() => {
  return `Sélection d'experts ${properties.tag.label}`;
});
</script>

<style scoped></style>
